const MARKETING_SITE_URL = 'https://www.wave.me';

export const goToMarketingSite = () => window.location.replace(MARKETING_SITE_URL);
